/**
 * QMS Board Skeleton
 * Loading placeholder for the entire Kanban board
 */

import { QmsTicketCardSkeleton } from './QmsTicketCardSkeleton';

interface QmsBoardSkeletonProps {
  columnCount?: number;
  cardsPerColumn?: number;
}

export function QmsBoardSkeleton({
  columnCount = 8,
  cardsPerColumn = 3,
}: QmsBoardSkeletonProps) {
  return (
    <div className="flex-1 overflow-x-auto overflow-y-hidden bg-gray-100">
      <div className="flex gap-4 p-6 h-full">
        {Array.from({ length: columnCount }).map((_, columnIndex) => (
          <div
            key={columnIndex}
            className="flex-shrink-0 w-80 bg-gray-50 rounded-lg p-4"
          >
            {/* Column header skeleton */}
            <div className="mb-4">
              <div className="h-6 w-40 bg-gray-200 rounded animate-pulse" />
              <div className="h-4 w-8 bg-gray-200 rounded animate-pulse mt-1" />
            </div>

            {/* Card skeletons */}
            <div className="space-y-3">
              {Array.from({ length: cardsPerColumn }).map((_, cardIndex) => (
                <QmsTicketCardSkeleton key={cardIndex} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
